export enum TransactionsActionType {
    HaltRealtimeTransactions = 'HALT_REALTIME_TRANSACTIONS',
    ResumeRealtimeTransactions = 'RESUME_REALTIME_TRANSACTIONS'
}

export interface TransactionsAction {
    type: TransactionsActionType;
    payload?: any;
}

export const haltRealtimeTransactionsAction: TransactionsAction = { type: TransactionsActionType.HaltRealtimeTransactions };
export const resumeRealtimeTransactionsAction: TransactionsAction = { type: TransactionsActionType.ResumeRealtimeTransactions };